const statusLabelText = {
  paddingY: 0.5,
  paddingX: 1,
  fontSize: 14,
};
const tableHeadCell = {
  paddingY: 2,
  paddingX: 1.5,
  fontWeight: '600',
  fontSize: { xs: 10, md: 14 },
};
const tableRowCell = {
  paddingY: 2,
  paddingX: 1.5,
  fontSize: { xs: 12, md: 16 },
};
const tableRowCellStatusText = {
  fontSize: 14,
};
const styles = {
  statusLabelText,
  tableHeadCell,
  tableRowCell,
  tableRowCellStatusText,
};

export { styles };
